export enum HgoHydroteaterCatalystRun {
  EOR = 'EOR',
  SOR = 'SOR',
}
